
import { Component, Prop, Vue } from 'vue-property-decorator';
import { VNode } from 'vue';

@Component
export default class LinkButton extends Vue {

  @Prop({ required: true }) public name: string;
  @Prop({ default: false }) public isSmall: boolean;
  @Prop({ default: '' }) public href: string;
  @Prop({ default: 'Click here' }) public label: string;

  public render(createElement: typeof Vue.prototype.$createElement): VNode {
    return createElement('a', {
      class: {
        'link': true,
        'link--small': this.isSmall,
      },
      attrs: {
        name: this.name,
        href: this.href,
      },
    }, this.label);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Base/LinkButton/LinkButton.vue